import { useCallback, useLayoutEffect, useRef } from 'react'

const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)'
export const SLIDE_BACK_MS = 320

/** Сдвиг, который ставит элемент в центр слота выбора (там стоит экран на холсте). */
const offsetToCenter = (el: HTMLElement): number | null => {
  const slot = el.closest<HTMLElement>('[data-testid="add-block-menu"]')
  if (!slot) return null
  const box = el.getBoundingClientRect()
  const area = slot.getBoundingClientRect()
  return area.left + area.width / 2 - (box.left + box.width / 2)
}

/**
 * Экран урока «отъезжает» вправо: превью выбора типа встаёт ровно туда, где
 * стоял экран на холсте, и плавно едет на своё место. `slideBack` — обратный
 * путь в центр, когда тип выбран (или окно закрыли). Считается от реальной
 * геометрии, а не от константы — ширина холста разная.
 */
export const useSlideFromCenter = <T extends HTMLElement>() => {
  const ref = useRef<T>(null)
  useLayoutEffect(() => {
    const el = ref.current
    const dx = el ? offsetToCenter(el) : null
    if (!el || dx === null || Math.abs(dx) < 1) return
    el.style.transition = 'none'
    el.style.transform = `translateX(${dx}px)`
    const frame = requestAnimationFrame(() => {
      el.style.transition = `transform 450ms ${EASE}`
      el.style.transform = ''
    })
    return () => cancelAnimationFrame(frame)
  }, [])

  const slideBack = useCallback(
    () =>
      new Promise<void>((resolve) => {
        const el = ref.current
        const dx = el ? offsetToCenter(el) : null
        if (el && dx !== null) {
          el.style.transition = `transform ${SLIDE_BACK_MS}ms ${EASE}`
          el.style.transform = `translateX(${dx}px)`
        }
        window.setTimeout(resolve, el && dx !== null ? SLIDE_BACK_MS : 0)
      }),
    [],
  )
  return { ref, slideBack }
}
